import { render, staticRenderFns } from "./ProgramLimitHistory.vue?vue&type=template&id=072e7199&"
import script from "./ProgramLimitHistory.vue?vue&type=script&lang=js&"
export * from "./ProgramLimitHistory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports